import HorizontalTimeline from '@components/HorizontalTimeline/index';
import React from 'react';

export default function CrioJourneyTimeline({ timeline }) {
  return <HorizontalTimeline timeline={timeline} />;
}
